import ChargeHelper from 'features/Charge/chargeHelper';
import FleetHelper from 'features/Fleet/fleetHelper';
import DropdownFilterTable from 'general/components/DropdownFilterTable';
import KTDropdownFilter from 'general/components/OtherKeenComponents/KTDropdownFilter';
import CustomDateRangePicker, {
    dateFilter,
    getDateFilterOption,
} from 'general/components/Others/CustomDateRangePicker';
import DashboardChartCard from 'general/components/quybka/Cards/DashboardChartCard';
import BarChart from 'general/components/quybka/Charts/BarChart';
import AppColors from 'general/constants/AppColors';
import AppResource from 'general/constants/AppResource';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import moment from 'moment';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

FleetDashboardView.propTypes = {};

function FleetDashboardView(props) {
    // MARK: ---- PROPERTIES ----
    const { user } = useSelector((state) => state.auth);
    // thong ke chi so cua DNVT
    const [fleetReport, setFleetReport] = useState({});
    // bieu do
    const [chartData, setChartData] = useState({});
    const [chartFilter, setChartFilter] = useState({
        from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
        to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
        selectedValue: dateFilter.baMuoiNgayGanNhat,
    });

    useEffect(() => {
        requestGetFleetReport();
    }, [])

    useEffect(() => {
        requestGetDashboardDaily(chartFilter);
    }, [chartFilter])

    const processVehicleData = (data) => {
        if (!data) return;
        const transactionCount = {
            CAR: [],
            BIKE: []
        };
        const totalEnergy = {
            CAR: [],
            BIKE: []
        };

        data?.forEach(day => {
            const date = day.date;

            const carData = day.vehicleTypes.find(v => v.vehicleType === "CAR");
            const bikeData = day.vehicleTypes.find(v => v.vehicleType === "BIKE");

            transactionCount.CAR.push({
                date: date,
                transactions: carData.transactionCount || 0
            });
            transactionCount.BIKE.push({
                date: date,
                transactions: bikeData.transactionCount || 0
            });

            totalEnergy.CAR.push({
                date: date,
                energy: carData.totalEnergy || 0
            });
            totalEnergy.BIKE.push({
                date: date,
                energy: bikeData.totalEnergy || 0
            });
        });

        return {
            transactionCount,
            totalEnergy
        };
    }

    const chartDataByVehicle = useMemo(() => {
        return processVehicleData(chartData?.dailyByVehicleType);
    }, [chartData])

    const mergeDataByDate = (dataByCar = [], dataByBike = [], dataName) => {
        const allDates = Array.from(
            new Set([...dataByCar.map(item => item.date), ...dataByBike.map(item => item.date)])
        );

        return allDates.map(date => {
            const carAmount = dataByCar.find(item => item.date === date)?.[dataName] || 0;
            const bikeAmount = dataByBike.find(item => item.date === date)?.[dataName] || 0;

            return { date, [dataName]: carAmount + bikeAmount };
        }).sort((a, b) => new Date(a.date) - new Date(b.date));
    };

    const getDataByType = (type, vehicleType, chartData, chartDataByVehicle) => {
        const typeMap = {
            transaction: {
                '': mergeDataByDate(
                    chartDataByVehicle?.transactionCount?.CAR,
                    chartDataByVehicle?.transactionCount?.BIKE,
                    'transactions'
                ),
                BIKE: chartDataByVehicle?.transactionCount?.BIKE,
                CAR: chartDataByVehicle?.transactionCount?.CAR
            },
            energy: {
                '': mergeDataByDate(
                    chartDataByVehicle?.totalEnergy?.CAR,
                    chartDataByVehicle?.totalEnergy?.BIKE,
                    'energy'
                ),
                BIKE: chartDataByVehicle?.totalEnergy?.BIKE,
                CAR: chartDataByVehicle?.totalEnergy?.CAR
            },
        };

        return typeMap[type]?.[vehicleType] || null;
    };

    const [energyType, setEnergyType] = useState('');
    const [energyFilter, setEnergyFilter] = useState({ ...chartFilter, energyType: energyType });
    // dien sac theo ngay
    const chartEnergyByDateEl = useMemo(() => {
        const energyByDate = getDataByType('energy', energyType, chartData, chartDataByVehicle);
        if (!energyByDate) return;
        let labels = energyByDate?.map((item) => Utils.formatDateTimeToString(item.date, 'DD'));
        let data = energyByDate?.map((item) => ((item.energy ?? 0) / 1000).toFixed(3));
        if (energyByDate?.length > 31) {
            const groupedData = _.groupBy(energyByDate, (item) => moment(item.date).format('MM/YYYY'));
            labels = Object.keys(groupedData);
            data = labels?.map((label) => {
                const total = groupedData[label]?.reduce((sum, item) => sum + item.energy, 0);
                return (total / 1000).toFixed(3);
            });
        }

        return (
            <DashboardChartCard
                title="Thống kê điện sạc"
                name="Tổng"
                value={
                    Utils.formatNumber(data?.reduce((sum, item) => _.toNumber(sum) + _.toNumber(item), 0)?.toFixed(3)) +
                    ' kWh'
                }
                valueColor="rgba(41, 132, 238, 1)"
                actionEl={
                    <DropdownFilterTable
                        id="energyType"
                        isLightButton={true}
                        toggleElementBorderRadius={10}
                        filterComponent={[
                            <div className="col-12 p-0">
                                <KTDropdownFilter
                                    label="Loại điện sạc"
                                    filterKey="energyType"
                                    options={[
                                        { name: 'Tất cả', value: '' },
                                        ...ChargeHelper.Data.vehicleTypeOptions,
                                    ]}
                                    selectedValue={energyFilter.energyType}
                                    handleChange={(value) => {
                                        setEnergyFilter({ ...energyFilter, energyType: value });
                                    }}
                                />
                            </div>,
                            <div className="col-12 p-0">
                                <label htmlFor="filterByDate" className="mb-0 mr-2 font-weight-bolder">
                                    Khoảng thời gian thống kê
                                </label>
                                <CustomDateRangePicker
                                    alignRight={true}
                                    toggleFontWeight="600"
                                    toggleElementBorderRadius={5}
                                    initialValue={energyFilter.selectedValue}
                                    onPressSave={(selectedValue, startDate, endDate) => {
                                        setEnergyFilter({
                                            ...energyFilter,
                                            from: startDate,
                                            to: endDate,
                                            selectedValue: selectedValue,
                                        });
                                    }}
                                />
                            </div>
                        ]}
                        resetDefaultTable={() => {
                            const updateChartFilter = {
                                ...chartFilter,
                                from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
                                to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
                                selectedValue: dateFilter.baMuoiNgayGanNhat,
                            };
                            setEnergyFilter({ ...updateChartFilter, energyType: '' });
                            setEnergyType('');
                            setChartFilter(updateChartFilter);
                        }}
                        saveFilter={() => {
                            const { energyType, ...dateFilter } = energyFilter;
                            setChartFilter(dateFilter);
                            setEnergyType(energyType);
                        }}
                        isDefaultFilter={Utils.checkDefaultFilter(
                            ['selectedValue', 'from', 'to'],
                            { ...chartFilter, energyType },
                            dateFilter.baMuoiNgayGanNhat,
                        )}
                    />
                }
                chartEl={
                    <BarChart
                        title="Điện sạc"
                        unit="kWh"
                        labels={labels}
                        data={data}
                        color="rgba(41, 132, 238, 0.4)"
                        hoverColor="rgba(41, 132, 238, 1)"
                    />
                }
            />
        );
    }, [chartDataByVehicle, chartData, chartFilter, energyFilter, energyType]);

    // phien sac theo ngay
    const [transactionType, setTransactionType] = useState('');
    const [transactionFilter, setTransactionFilter] = useState({ ...chartFilter, transactionType: transactionType });
    const chartTransactionByDateEl = useMemo(() => {
        const transactionByDate = getDataByType('transaction', transactionType, chartData, chartDataByVehicle);
        if (!transactionByDate) return;
        let labels = transactionByDate?.map((item) => Utils.formatDateTimeToString(item.date, 'DD'));
        let data = transactionByDate?.map((item) => item.transactions ?? 0);

        if (transactionByDate?.length > 31) {
            const groupedData = _.groupBy(transactionByDate, (item) =>
                moment(item.date).format('MM/YYYY')
            );
            labels = Object.keys(groupedData);
            data = labels?.map((label) => {
                const total = groupedData[label]?.reduce((sum, item) => sum + item.transactions, 0);
                return total;
            });
        }

        return (
            <DashboardChartCard
                title="Thống kê phiên sạc"
                name="Tổng"
                value={
                    Utils.formatNumber(data?.reduce((sum, item) => _.toNumber(sum) + _.toNumber(item), 0)) +
                    ' phiên sạc'
                }
                valueColor="rgba(88, 86, 214, 1)"
                actionEl={
                    <DropdownFilterTable
                        id="transactionType"
                        isLightButton={true}
                        toggleElementBorderRadius={10}
                        filterComponent={[
                            <div className="col-12 p-0">
                                <KTDropdownFilter
                                    label="Loại phiên sạc"
                                    filterKey="transactionType"
                                    options={[
                                        { name: 'Tất cả', value: '' },
                                        ...ChargeHelper.Data.vehicleTypeOptions,
                                    ]}
                                    selectedValue={transactionFilter.transactionType}
                                    handleChange={(value) => {
                                        setTransactionFilter({ ...transactionFilter, transactionType: value });
                                    }}
                                />
                            </div>,
                            <div className="col-12 p-0">
                                <label htmlFor="filterByDate" className="mb-0 mr-2 font-weight-bolder">
                                    Khoảng thời gian thống kê
                                </label>
                                <CustomDateRangePicker
                                    alignRight={true}
                                    toggleFontWeight="600"
                                    toggleElementBorderRadius={5}
                                    initialValue={transactionFilter.selectedValue}
                                    onPressSave={(selectedValue, startDate, endDate) => {
                                        setTransactionFilter({
                                            ...transactionFilter,
                                            from: startDate,
                                            to: endDate,
                                            selectedValue: selectedValue,
                                        });
                                    }}
                                />
                            </div>
                        ]}
                        resetDefaultTable={() => {
                            const updateChartFilter = {
                                ...chartFilter,
                                from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
                                to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
                                selectedValue: dateFilter.baMuoiNgayGanNhat,
                            };
                            setTransactionFilter({ ...updateChartFilter, transactionType: '' });
                            setTransactionType('');
                            setChartFilter(updateChartFilter);
                        }}
                        saveFilter={() => {
                            const { transactionType, ...dateFilter } = transactionFilter;
                            setChartFilter(dateFilter);
                            setTransactionType(transactionType);
                        }}
                        isDefaultFilter={Utils.checkDefaultFilter(
                            ['selectedValue', 'from', 'to'],
                            { ...chartFilter, transactionType },
                            dateFilter.baMuoiNgayGanNhat,
                        )}
                    />
                }
                chartEl={
                    <BarChart
                        title="Phiên sạc"
                        unit="phiên sạc"
                        labels={labels}
                        data={data}
                        color="rgba(88, 86, 214, 0.4)"
                        hoverColor="rgba(88, 86, 214, 1)"
                    />
                }
            />
        );
    }, [chartDataByVehicle, chartData, chartFilter, transactionFilter, transactionType]);

    // thong ke nap tien theo ngay
    const chartTopupByDateEl = useMemo(() => {
        const topupCountByDate = chartData?.topupByDate ?? [];
        let labels = topupCountByDate?.map((item) => Utils.formatDateTimeToString(item.date, 'DD'));
        let data = topupCountByDate?.map((item) => item.amount ?? 0);

        if (topupCountByDate?.length > 31) {
            const groupedData = _.groupBy(topupCountByDate, (item) =>
                moment(item.date).format('MM/YYYY')
            );
            labels = Object.keys(groupedData);
            data = labels?.map((label) => {
                const total = groupedData[label]?.reduce((sum, item) => sum + item.amount, 0);
                return total;
            });
        }

        return (
            <DashboardChartCard
                title="Thống kê nạp tiền"
                name="Tổng"
                value={
                    Utils.formatNumber(data?.reduce((sum, item) => _.toNumber(sum) + _.toNumber(item), 0)) +
                    ' VNĐ'
                }
                valueColor="#30BD6F"
                actionEl={
                    <CustomDateRangePicker
                        alignRight={true}
                        toggleFontWeight="600"
                        toggleElementBorderRadius={10}
                        initialValue={chartFilter.selectedValue}
                        onPressSave={(selectedValue, startDate, endDate) => {
                            setChartFilter({
                                from: startDate,
                                to: endDate,
                                selectedValue: selectedValue,
                            });
                        }}
                    />
                }
                chartEl={
                    <BarChart
                        title="VNĐ"
                        unit="VNĐ"
                        labels={labels}
                        data={data}
                        color="#30BD6F4D"
                        hoverColor="#30BD6F"
                    />
                }
            />
        );
    }, [chartData, chartFilter]);

    // thong ke tieu tien theo ngay
    const chartPaymentByDateEl = useMemo(() => {
        const paymentCountByDate = chartData?.paymentByDate ?? [];
        let labels = paymentCountByDate?.map((item) => Utils.formatDateTimeToString(item.date, 'DD'));
        let data = paymentCountByDate?.map((item) => item.amount ?? 0);

        if (paymentCountByDate?.length > 31) {
            const groupedData = _.groupBy(paymentCountByDate, (item) =>
                moment(item.date).format('MM/YYYY')
            );
            labels = Object.keys(groupedData);
            data = labels?.map((label) => {
                const total = groupedData[label]?.reduce((sum, item) => sum + item.amount, 0);
                return total;
            });
        }

        return (
            <DashboardChartCard
                title="Thống kê tiêu tiền"
                name="Tổng"
                value={
                    Utils.formatNumber(data?.reduce((sum, item) => _.toNumber(sum) + _.toNumber(item), 0)) +
                    ' VNĐ'
                }
                valueColor="#FF6D70"
                actionEl={
                    <CustomDateRangePicker
                        alignRight={true}
                        toggleFontWeight="600"
                        toggleElementBorderRadius={10}
                        initialValue={chartFilter.selectedValue}
                        onPressSave={(selectedValue, startDate, endDate) => {
                            setChartFilter({
                                from: startDate,
                                to: endDate,
                                selectedValue: selectedValue,
                            });
                        }}
                    />
                }
                chartEl={
                    <BarChart
                        title="VNĐ"
                        unit="VNĐ"
                        labels={labels}
                        data={data}
                        color="#FF6D704D"
                        hoverColor="#FF6D70"
                    />
                }
            />
        );
    }, [chartData, chartFilter]);

    // MARK: ---- METHODS ----
    const requestGetFleetReport = () => {
        FleetHelper.API.requestGetFleetReport({ month: moment().format('YYYY-MM') }).then((res) => {
            setFleetReport(res ?? {});
        });
    };

    const requestGetDashboardDaily = (filter) => {
        const params = _.pickBy(
            filter,
            (value) => value !== null && value !== undefined && value !== ''
        );
        FleetHelper.API.requestGetDashboardDaily(params).then((res) => {
            setChartData(res ?? {});
        });
    };

    return (
        <div className="mt-4" style={{ minHeight: '900px' }}>
            <div className="row m-0 p-0 px-2">
                <div className="col-lg-6 px-2">
                    {UIHelper.buildCard(
                        <div>
                            <div
                                className="d-flex flex-column p-4"
                                style={{
                                    borderBottom: `1px solid ${AppColors.gray[200]}`,
                                }}
                            >
                                <span style={UIHelper.buildFontStyle('700', '30px', AppColors.gray[600])}>
                                    {user?.fullname}
                                </span>
                                <span style={UIHelper.buildFontStyle('700', '26px', AppColors.primary)}>
                                    {ChargeHelper.Utils.getUserRoleName(user?.role)}
                                </span>
                            </div>
                            <div className="d-flex flex-column gap-3 pt-2 pb-6">
                                <div className="px-4 d-flex flex-column gap-3 mt-4">
                                    {UIHelper.buildStatisticItem(
                                        '#FF6D70',
                                        <div className="d-flex align-items-center gap-2">
                                            Đã chi trong tháng
                                        </div>,
                                        Utils.formatNumber(fleetReport?.totalSpent ?? 0) + ' VNĐ',
                                        null,
                                        'fa-solid fa-battery-bolt'
                                    )}
                                    {UIHelper.buildStatisticItem(
                                        '#30BD6F',
                                        <div className="d-flex align-items-center gap-2">
                                            Số tiền đã nạp trong tháng
                                        </div>,
                                        Utils.formatNumber(fleetReport?.totalTopup ?? 0) + ' VNĐ',
                                        null,
                                        'fa-solid fa-hand-holding-dollar'
                                    )}
                                </div>
                            </div>
                        </div>,
                        false,
                        false,
                        true,
                        true
                    )}
                </div>
                <div className="col-lg-6 px-2">
                    <img
                        className="w-100 h-100 object-fit-cover"
                        src={AppResource.images.evg.fleetDashboardBg}
                        style={{ borderRadius: 10 }}
                    />
                </div>
            </div>

            {/* bieu do */}
            <div className="mt-4">
                <div className="row m-0 p-0 px-2">
                    {/* thong ke dien sac */}
                    <div className="col-lg-6 px-2 mb-4">{chartEnergyByDateEl}</div>
                    {/* thong ke phien sac */}
                    <div className="col-lg-6 px-2 mb-4">{chartTransactionByDateEl}</div>
                    {/* thong ke nap tien */}
                    <div className="col-lg-6 px-2 mb-4">{chartTopupByDateEl}</div>
                    {/* thong ke tieu tien */}
                    <div className="col-lg-6 px-2 mb-4">{chartPaymentByDateEl}</div>
                </div>
            </div>
        </div>
    );
}

export default FleetDashboardView;
